import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=bfe2d20e&scoped=true"
import script from "./SubTitle.vue?vue&type=script&lang=js"
export * from "./SubTitle.vue?vue&type=script&lang=js"
import style0 from "./SubTitle.vue?vue&type=style&index=0&id=bfe2d20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe2d20e",
  null
  
)

export default component.exports